module.exports = __webpack_public_path__ + "img/raise_arm.951ab398.svg";